<template>
  <div class="p-4 sm:p-6 lg:p-8">
    <!-- Header -->
    <div class="flex justify-between items-center border-b border-gray-200 py-4 mb-6">
      <h1 class="text-lg font-normal">Personnalisations</h1>
    </div>

    <form @submit.prevent="savePages" class="flex flex-col gap-6">

      <!-- Mentions légales -->
      <div>
        <label class="font-medium text-gray-700 mb-2 block">Mentions légales</label>
        <quill-editor
          v-model="mentionsLegales"
          :options="editorOptions"
          class="border rounded-lg min-h-[300px] bg-white shadow"
        />
      </div>

      <!-- Politique de confidentialité -->
      <div>
        <label class="font-medium text-gray-700 mb-2 block">Politique de confidentialité</label>
        <quill-editor
          v-model="politiqueConfidentialite"
          :options="editorOptions"
          class="border rounded-lg min-h-[300px] bg-white shadow"
        />
      </div>

      <!-- Bouton -->
      <div class="flex justify-end">
        <button
          type="submit"
          class="px-6 py-3 bg-blue-600 text-white font-medium rounded-lg shadow hover:bg-blue-700 transition"
        >
          Enregistrer
        </button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { reactive, onMounted } from 'vue'
import { quillEditor } from 'vue3-quill'  // ✅ même import que ton autre fichier

const mentionsLegales = reactive('')
const politiqueConfidentialite = reactive('')

const editorOptions = {
  theme: 'snow',
  modules: {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
      [{ align: [] }],
      [{ color: [] }, { background: [] }],
      ['link', 'image', 'video'],
      ['clean']
    ]
  }
}

// Charger le contenu existant si nécessaire
onMounted(() => {
  // fetch('/api/pages-legales').then(...)
})

function savePages() {
  console.log('Mentions légales:', mentionsLegales)
  console.log('Politique de confidentialité:', politiqueConfidentialite)
  alert('Pages légales sauvegardées !')
}
</script>

<style>
.ql-editor {
  min-height: 250px;
}
</style>
